import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brackets', 'Brackets', [["path",{"d":"M8 4h-3v16h3"}],["path",{"d":"M16 4h3v16h-3"}]]);